module.exports = __webpack_public_path__ + "img/diamonds-6.157ebfed.svg";